// # region imports

// --- Angular
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

// --- HS Code
import { OidcService } from '../core/services';

// #endregion

@Component({
  selector: 'app-signout-redirect-callback',
  template: `<div></div>`
})
export class SignoutRedirectCallbackComponent implements OnInit {

  constructor(
    private oidcService: OidcService,
    private _router: Router) { }

  ngOnInit(): void {
    this.oidcService.finishLogout()
    .then(_ => {
      this._router.navigate(['/'], { replaceUrl: true });
    })
  }

}
